import { useDispatch, useSelector } from "react-redux";
import { logout } from "../store/actions";
import { API_BASE_URL, isLocalAuthSession } from "./config";
import { clearRefreshTimer } from "./tokenRefresh";

// Clears local state first, then hard-redirects (not navigate()) to the auth
// server's OIDC RP-initiated logout endpoint so it also ends the server-side
// SSO session/cookie — without this, only this app's local token gets
// cleared and the next "Login" click silently re-authenticates via the
// still-live SSO session instead of showing the login page.
// Spring Authorization Server derives the client from id_token_hint itself,
// so no client_id param is needed.
export default function useLogout() {
  const dispatch = useDispatch();
  const idToken = useSelector((state) => state.auth?.idToken);
  const isLocal = useSelector((state) => isLocalAuthSession(state.auth));
  return () => {
    const savedIdToken = idToken;
    clearRefreshTimer();

    // Brand / manufacturer password login: stateless JWT, no server session or SSO to end.
    if (isLocal) {
      dispatch(logout());
      window.location.href = "/";
      return;
    }

    dispatch(logout());

    const redirectUrl = window.location.origin + "/";
    try {
      const logoutUrl = new URL(`${API_BASE_URL}/connect/logout`);
      logoutUrl.searchParams.append("post_logout_redirect_uri", redirectUrl);
      if (savedIdToken) {
        logoutUrl.searchParams.append("id_token_hint", savedIdToken);
      }
      window.location.href = logoutUrl.toString();
    } catch (e) {
      window.location.href = redirectUrl;
      console.log(e, "error message");
    }
  };
}
